var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white-bg pl-mid pr-mid pt-min mb-max test-form"},[(_vm.project)?_c('input',{attrs:{"name":"project_id","type":"hidden"},domProps:{"value":_vm.project.id}}):_vm._e(),_vm._v(" "),_vm._l((_vm.type.headings),function(heading,key,index){return _c('heading',{key:key,attrs:{"heading":heading,"unique":['headings', key],"test":_vm.test,"old":_vm.old}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ba771f7","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/printtest/PrintTest.vue
// module id = cRhp
// module chunks = 0 1